import apiRequest from "./apiClient";

export async function fetchCategories({ activeOnly = false } = {}) {
  const suffix = activeOnly ? "?activeOnly=true" : "";
  const body = await apiRequest(`/api/v1/devices/get/category${suffix}`);
  return body.data;
}

export async function saveCategory(category) {
  const body = await apiRequest("/api/v1/devices/add/category", {
    method: "POST",
    body: JSON.stringify(category),
  });
  return body.data;
}

export async function fetchDeviceById(deviceId) {
  const body = await apiRequest(`/api/v1/devices/${deviceId}`);
  return body.data;
}

export async function searchDevices({ query = "", brandId, page = 0, size = 20 } = {}) {
  const params = new URLSearchParams({ query, page, size });
  if (brandId) params.set("brandId", brandId);
  const body = await apiRequest(`/api/v1/devices/search?${params}`);
  return body.data;
}

export async function fetchDevicesByBrand(brandId, categoryId, page = 0, size = 20) {
  const params = new URLSearchParams({ page, size });
  const body = await apiRequest(
    `/api/v1/devices/brands/${brandId}/${categoryId}/devices?${params}`
  );
  return body.data;
}

export async function createDevice(payload) {
  const body = await apiRequest("/api/v1/devices", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateDevice(deviceId, payload) {
  const body = await apiRequest(`/api/v1/devices/${deviceId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function deleteDevice(deviceId) {
  await apiRequest(`/api/v1/devices/${deviceId}`, { method: "DELETE" });
}

export async function toggleDevicePopular(deviceId) {
  await apiRequest(`/api/v1/devices/${deviceId}/popular`, { method: "PUT" });
}

export async function fetchSeries(brandId, categoryId) {
  const params = new URLSearchParams({ brandId, categoryId });
  const body = await apiRequest(`/api/v1/devices/series?${params}`);
  return body.data;
}

export async function createSeries(payload) {
  const body = await apiRequest("/api/v1/devices/series", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateSeries(seriesId, payload) {
  const body = await apiRequest(`/api/v1/devices/series/${seriesId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}
